import { ReactNode } from 'react';
import config from 'theme/config';
export const getAmountFromSiteId = (
  t: (
    translationKey: string | undefined,
    interpolateObject?: {
      [key: string]: string | undefined;
    }
  ) => React.ReactNode
) => {
  const siteRegion: string | undefined = process.env.REACT_APP_REGION;
  if (siteRegion) {
    const siteRegionTranslationValues: string[] = config.settings.regions[siteRegion];
    if (!siteRegionTranslationValues) {
      console.log('No Matching Region values');
      return null;
    }

    if (siteRegionTranslationValues.length === 1) {
      return t(siteRegionTranslationValues[0]);
    }
    return t(siteRegionTranslationValues[1], { value: siteRegionTranslationValues[0] });
  }
  console.log('Region is not set');
  return null;
};
